import {analyticsLogEvent} from '../api'

export function analyticsEventCloseLayer() {
    const eventName = 'close_layer'

    analyticsLogEvent(eventName, {})
}
